module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-bottom-stone-path.98ac8b11.png";